module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "scroll": _vm.stickyNavigation
    }
  }, [_c('a', {
    staticClass: "tone-skip-link",
    attrs: {
      "href": "#main-content"
    },
    on: {
      "click": _vm.focusMain
    }
  }, [_vm._v("Skip to main content")]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    class: {
      'unauth-header': !_vm.user
    },
    style: ({
      backgroundColor: _vm.getCorpHeaderColor + ' !important'
    })
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ToneHeader', {
    staticClass: "gradient-tone-header",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor + ' !important'
    }),
    attrs: {
      "hide-nav": _vm.hideNav
    }
  })], 1)])])]), _vm._v(" "), _c('main', {
    ref: "mainContent",
    staticClass: "text-center min-body-height",
    attrs: {
      "id": "main-content",
      "tabindex": "-1",
      "aria-label": "Main content"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    },
    on: {
      "after-enter": _vm.onViewReady,
      "after-leave": _vm.onViewReady
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sr-only",
    attrs: {
      "role": "status",
      "aria-live": "polite",
      "aria-atomic": "true"
    }
  }, [_vm._v(_vm._s(_vm.accessibilityStatus))]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    style: ({
      backgroundColor: _vm.getCorpFooterColor
    })
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ToneFooter', {
    staticClass: "gradient-tone-header"
  })], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5930af97", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5930af97"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/App.vue